<template>
  <div class="container">
    <head-nav-bar
      v-if="isPage !== false"
      :title="title"
      :fixed="true"
      @click-left="$router.go(-1)"
    />
    <div
      v-if="isPage !== false || (info && info.Id)"
      :class="['content', { notPage: isPage === false }]"
    >
      <div class="header-title" v-if="isPage === false">
        <h3>{{ info.hospitalName }}</h3>
        <h4>{{ templateData.name }}</h4>
      </div>
      <div v-if="readonly" class="submit-result">
        <van-icon v-if="isPage !== false" name="passed" class="icon" />
        <div v-if="isPage !== false" style="margin-bottom:10px;">提交成功</div>
        <div v-if="this.epidemicType == 1">
          筛查结果为：
          <van-tag v-if="info.resultValue == '合格'" type="success">{{
            info.resultValue
          }}</van-tag>
          <van-tag v-else type="danger">{{ info.resultValue }}</van-tag>
        </div>
        <!-- <p v-if="isPage === false">提交时间：{{ info.CreationTime }}</p> -->
        <p>提交时间：{{ info.creationTime }}</p>
      </div>
      <div
        v-if="this.epidemicType == 1 || (!readonly && this.epidemicType == 2)"
      >
        <div v-if="templateData.formTemplateType == 1" class="baseForm">
          <van-form>
            <van-field
              v-if="baseFormData.diagnosisCardNo"
              required
              v-model="baseFormData.diagnosisCardNo"
              name="就诊卡号"
              label="就诊卡号"
              :readonly="true"
              :rules="[{ required: true }]"
            />
            <van-field
              required
              v-model="baseFormData.patientName"
              name="姓名"
              label="姓名"
              placeholder="请填写姓名"
              :readonly="
                readonly || baseFormData.diagnosisCardNo ? true : false
              "
              :rules="[{ required: true }]"
            />
            <van-field
              type="tel"
              maxlength="11"
              v-model="baseFormData.patientContactPhone"
              name="电话"
              label="电话"
              placeholder="请填写电话"
              required
              :readonly="readonly"
              :rules="[{ required: true }]"
            />
            <van-field
              v-if="baseFormData.diagnosisCardNo"
              v-model="baseFormData.patientIdentityNo"
              name="证件号码"
              label="证件号码"
              placeholder="请填写证件号码"
              :readonly="readonly"
              :error-message="idCardErrorMsg"
            />
            <van-field
              v-else
              v-model="baseFormData.patientIdentityNo"
              name="身份证号"
              label="身份证号"
              placeholder="请填写身份证号"
              required
              :readonly="readonly"
              :error-message="idCardErrorMsg"
              @change="onPatientIdentityNoChange"
              :rules="[{ required: true }]"
            />
          </van-form>
        </div>
        <div
          class="text-box"
          v-if="templateData.templateText"
          v-html="templateData.templateText"
        ></div>
        <div class="form-config-list">
          <template v-for="(item, index) in formConfigData">
            <div
              :key="index"
              class="form-config-item"
              v-if="!hideItemKeys.includes(`${index}`)"
            >
              <div class="title">
                {{ item.title }}
              </div>
              <div class="subject-list">
                <template v-for="(subject, jindex) in item.childItemList">
                  <div
                    :key="jindex"
                    :class="['subject-item', subject.layout]"
                    v-if="!hideItemKeys.includes(`${index}_${jindex}`)"
                  >
                    <div
                      :class="[
                        'subject-title',
                        { required: subject.isRequired },
                      ]"
                    >
                      <van-checkbox
                        :disabled="readonly"
                        shape="square"
                        style="display: inline-block;"
                        v-if="subject.operartionType == 4"
                        v-model="
                          formData[
                            `${index}_${jindex}_${
                              subject.isEscortInput ? '0' : ''
                            }`
                          ]
                        "
                        @change="
                          onCheckedChange($event, subject, index, jindex, 0)
                        "
                      ></van-checkbox>
                      {{ subject.title }}
                    </div>
                    <div
                      v-if="subject.operartionType != 4"
                      :class="['option-list', { flex: subject.isEscortInput }]"
                    >
                      <span v-if="subject.isEscortInput" class="option-title"
                        >患者：</span
                      >
                      <span>
                        <van-radio-group
                          :disabled="readonly"
                          direction="horizontal"
                          v-if="subject.operartionType == 0"
                          v-model="
                            formData[
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`
                            ]
                          "
                          @change="
                            onCheckedChange($event, subject, index, jindex, 0)
                          "
                        >
                          <van-radio
                            v-for="(option, oindex) in subject.optionList"
                            :key="oindex"
                            :name="option.value"
                            >{{ option.text }}</van-radio
                          >
                        </van-radio-group>

                        <van-checkbox-group
                          :disabled="readonly"
                          direction="horizontal"
                          v-else-if="subject.operartionType == 1"
                          v-model="
                            formData[
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`
                            ]
                          "
                          @change="
                            onCheckedChange($event, subject, index, jindex, 0)
                          "
                        >
                          <van-checkbox
                            v-for="(option, oindex) in subject.optionList"
                            :key="oindex"
                            :name="option.value"
                            shape="square"
                            >{{ option.text }}</van-checkbox
                          >
                        </van-checkbox-group>

                        <van-field
                          :readonly="readonly"
                          v-if="subject.operartionType == 2"
                          v-model="
                            formData[
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`
                            ]
                          "
                          :placeholder="!readonly ? '请点击输入' : ''"
                          @change="
                            onInputChange(
                              $event,
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`,
                            )
                          "
                        />
                        <van-field
                          :readonly="true"
                          v-if="subject.operartionType == 5"
                          v-model="
                            formData[
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`
                            ]
                          "
                          :placeholder="!readonly ? '请点击选择日期' : ''"
                          @click="
                            onShowDatePicker(
                              `${index}_${jindex}_${
                                subject.isEscortInput ? '0' : ''
                              }`,
                            )
                          "
                        />
                      </span>
                    </div>
                    <div
                      v-if="
                        subject.operartionType != 4 && subject.isEscortInput
                      "
                      :class="['option-list', { flex: subject.isEscortInput }]"
                    >
                      <span v-if="subject.isEscortInput" class="option-title"
                        >陪护：</span
                      >
                      <span>
                        <van-radio-group
                          :disabled="readonly"
                          direction="horizontal"
                          v-if="subject.operartionType == 0"
                          v-model="formData[`${index}_${jindex}_1`]"
                          @change="
                            onCheckedChange($event, subject, index, jindex, 1)
                          "
                        >
                          <van-radio
                            v-for="(option, oindex) in subject.optionList"
                            :key="oindex"
                            :name="option.value"
                            >{{ option.text }}</van-radio
                          >
                        </van-radio-group>

                        <van-checkbox-group
                          :disabled="readonly"
                          direction="horizontal"
                          v-else-if="subject.operartionType == 1"
                          v-model="formData[`${index}_${jindex}_1`]"
                          @change="
                            onCheckedChange($event, subject, index, jindex, 1)
                          "
                        >
                          <van-checkbox
                            v-for="(option, oindex) in subject.optionList"
                            :key="oindex"
                            :name="option.value"
                            shape="square"
                            >{{ option.vext }}</van-checkbox
                          >
                        </van-checkbox-group>

                        <van-field
                          :readonly="readonly"
                          v-if="subject.operartionType == 2"
                          v-model="formData[`${index}_${jindex}_1`]"
                          :placeholder="!readonly ? '请点击输入' : ''"
                        />
                        <van-field
                          :readonly="true"
                          v-if="subject.operartionType == 5"
                          v-model="formData[`${index}_${jindex}_1`]"
                          :placeholder="!readonly ? '请点击选择日期' : ''"
                          @click="onShowDatePicker(`${index}_${jindex}_1`)"
                        />
                      </span>
                    </div>
                    <div class="subject-remark">
                      {{ subject.remark }}
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
        <div class="text-box" v-html="templateData.tipsRemark"></div>
        <div v-if="!readonly" class="action-wraper">
          <van-button type="info" block @click="onSubmit" :loading="loading"
            >确认提交</van-button
          >
        </div>
      </div>
    </div>
    <van-calendar
      v-model="showDatePicker"
      :min-date="minDate"
      @confirm="onConfirmDatePicker"
    />
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Field,
  Button,
  Form,
  Dialog,
  Icon,
  Tag,
  Calendar,
} from "vant";
import cloneDeep from "lodash/cloneDeep";
import { IdentityCodeValid, getAges, formatDate } from "@/utils/common";
export default {
  components: {
    [Form.name]: Form,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Calendar.name]: Calendar,
  },
  props: {
    isPage: {
      type: [String, Boolean],
      default: "",
    },
  },
  data() {
    return {
      title: "流行病筛查表",
      templateData: {},
      formConfigData: [],
      formData: {},
      hideItemKeys: [], //隐藏的key
      baseFormData: {},
      idCardErrorMsg: "",
      readonly: false,
      info: {},
      contactInfo: {},
      showDatePicker: false,
      currentDatePickerField: "",
      minDate: new Date(1900, 0, 1),
      loading: false,
      epidemicType: "1",
    };
  },
  created() {
    const query = this.$route.query;
    let hospitalId = 0;
    if (query.hospitalId) {
      hospitalId = query.hospitalId;
    }
    if (query.epidemicType) {
      this.epidemicType = query.epidemicType;
    }
    this.baseFormData = { ...query, hospitalId };
    if (query.contactId) {
      this.fetchContactInfo(query.contactId);
    }
    this.fetchFormTemplate();
    // if (query.PatientIdentityNo) {
    //   this.onPatientIdentityNoChange({
    //     target: {
    //       value: query.PatientIdentityNo
    //     }
    //   });
    // }
  },
  methods: {
    fetchContactInfo(id) {
      this.$post("Contact_Info", { id: id }).then(res => {
        this.contactInfo = res.data;
        let patientAge = 0;
        if (this.contactInfo.cardholderBirthDate) {
          patientAge = getAges(this.contactInfo.cardholderBirthDate);
        }
        this.baseFormData = {
          ...this.baseFormData,
          diagnosisCardNo: this.contactInfo.diagnosisCardNo,
          patientName: this.contactInfo.cardholderName,
          patientSex: this.contactInfo.cardholderSex,
          patientIdentityNo: this.contactInfo.identityDocNoProcted,
          patientContactPhone: this.contactInfo.cardholderContactPhone,
          patientAge,
        };
        setTimeout(() => {
          if (this.templateData.formTemplateType == 0) {
            // 默认模板
            this.formData = {
              "0_0_": this.contactInfo.cardholderName,
              "0_1_": this.contactInfo.cardholderSex + "",
              "0_2_": patientAge,
              "0_5_": this.contactInfo.cardholderContactPhone,
              "0_6_": this.contactInfo.identityDocNo,
            };
          } else if (this.templateData.formTemplateType == 2) {
            // 2022模板
            this.formData = {
              "0_0_": this.contactInfo.cardholderName,
              "0_1_": this.contactInfo.identityDocNo,
              "0_2_": this.contactInfo.cardholderSex + "",
              "0_3_": patientAge,
              "0_4_": this.contactInfo.cardholderContactPhone,
              "0_5_": this.contactInfo.cardholderContactAddress,
            };
          }
        }, 500);
      });
    },
    fetchFormTemplate() {
      this.$post("getDefaultFormInfo", {
        epidemicType: this.epidemicType,
      }).then(res => {
        const data = res.data;
        this.title = data.name;
        this.templateData = data;
        this.formConfigData = data.itemList;
        this.initTemplate(data.itemList);
        if (
          data.formTemplateType == 2 &&
          !this.$route.query.contactId &&
          data.epidemicType == 1
        ) {
          // 2022模板
          // this.formData = {
          //   "0_0_": "",
          //   "0_1_": "",
          //   "0_2_": "",
          //   "0_3_": "",
          //   "0_4_": "",
          //   "0_5_": ""
          // };
        }
      });
    },
    // 初始化隐藏的问题
    initTemplate(itemList) {
      let hideItemKeys = [];
      if (itemList && itemList.length) {
        for (let i = 0; i < itemList.length; i++) {
          const item = itemList[i];
          if (item.childItemList && item.childItemList.length) {
            for (let j = 0; j < item.childItemList.length; j++) {
              const subject = item.childItemList[j];
              if (subject.eventList && subject.eventList.length) {
                for (let e = 0; e < subject.eventList.length; e++) {
                  const ev = subject.eventList[e];
                  if (
                    (ev.name == "showFormItem" || ev.name == "showFormBox") &&
                    ev.value
                  ) {
                    for (let o = 0; o < ev.relateOptionList.length; o++) {
                      const ol = ev.relateOptionList[o];
                      hideItemKeys.push(ol.text);
                    }
                  }
                }
              }
            }
          }
        }
      }
      this.hideItemKeys = hideItemKeys;
    },
    onCheckedChange(val, subject, index, jindex, type) {
      if (subject.eventList && subject.eventList.length) {
        for (let i = 0; i < subject.eventList.length; i++) {
          const event = subject.eventList[i];

          if (
            event.name == "setFromValue" &&
            event.relateOptionList &&
            event.relateOptionList.length &&
            val &&
            subject.operartionType == 4
          ) {
            let formData = {};
            // 设置一些值
            for (let j = 0; j < event.relateOptionList.length; j++) {
              const eventItem = event.relateOptionList[j];
              if (subject.isEscortInput) {
                formData[`${eventItem.text}_0`] = eventItem.value;
                formData[`${eventItem.text}_1`] = eventItem.value;
              } else {
                formData[`${eventItem.text}_`] = eventItem.value;
              }
            }
            this.formData = { ...this.formData, ...formData };
          } else if (
            (event.name == "showFormItem" || event.name == "showFormBox") &&
            event.relateOptionList &&
            event.relateOptionList.length
          ) {
            // 值等于指定值时显示
            let hideItemKeys = [...this.hideItemKeys];
            for (let j = 0; j < event.relateOptionList.length; j++) {
              const eventItem = event.relateOptionList[j];
              let key = `${index}_${jindex}`;
              let valueList = [];
              if (subject.isEscortInput) {
                if (type == 0) {
                  valueList.push(val);
                  valueList.push(this.formData[key + "_1"]);
                } else {
                  valueList.push(this.formData[key + "_0"]);
                  valueList.push(val);
                }
              } else {
                valueList.push(val);
              }
              if (valueList.includes(event.value)) {
                hideItemKeys = hideItemKeys.filter(p => p != eventItem.text);
              } else {
                hideItemKeys.push(eventItem.text);
              }
            }
            this.hideItemKeys = hideItemKeys;
          }
        }
      }
    },
    onSubmit() {
      const that = this;
      const { formConfigData, formData, baseFormData, hideItemKeys } = this;
      this.loading = true;

      let itemList = cloneDeep(formConfigData);
      let isRequiredError = false;

      for (let i = 0; i < itemList.length; i++) {
        const item = itemList[i];
        if (
          !hideItemKeys.includes(i + "") &&
          item.childItemList &&
          item.childItemList.length
        ) {
          for (let j = 0; j < item.childItemList.length; j++) {
            const subject = item.childItemList[j];
            const key = `${i}_${j}`;
            let formKey = key + "_";
            let key0 = key + "_0";
            let key1 = key + "_1";
            let formKey1 = "";
            if (subject.isEscortInput) {
              formKey = key0;
              formKey1 = key1;
            }
            console.log(formData, formKey, formData[formKey], subject);
            if (formData[formKey] || formData[formKey] === false) {
              if (subject.operartionType == 1) {
                subject.valueList = formData[formKey];
              } else {
                subject.valueList = [formData[formKey]];
              }
              if (subject.isEscortInput) {
                subject.ValueList.push(formData[key1]);
              }
              if (
                subject.operartionType == 4 &&
                subject.valueList[0] === false &&
                subject.isRequired &&
                !hideItemKeys.includes(key)
              ) {
                isRequiredError = true;
              }
            } else if (
              subject.isEscortInput &&
              formKey1 &&
              (formData[formKey1] || formData[formKey1] === false)
            ) {
              subject.valueList = ["", formData[key1]];
            } else if (subject.isRequired && !hideItemKeys.includes(key)) {
              isRequiredError = true;
            }
          }
        }
      }
      if (isRequiredError) {
        Dialog.alert({
          message: "请完善带*号必填项",
        }).then(() => {
          // on close
        });
        this.loading = false;
        return false;
      }

      const json = {
        ...this.templateData,
        ...baseFormData,
        id: null,
        itemList: itemList,
      };
      if (
        this.contactInfo &&
        this.contactInfo.identityDocNo &&
        baseFormData.patientIdentityNo === this.contactInfo.identityDocNoProcted
      ) {
        json.patientIdentityNo = this.contactInfo.identityDocNo;
      }

      console.log(json);
      this.$post("AddFormRecordInfo", json)
        .then(res => {
          this.loading = false;
          this.fetchInfo(res.data);
          if (this.$route.query.callbackUrl) {
            Dialog.alert({
              title: "提交成功！",
              message:
                this.$route.query.callbackUrl == "servePreOrderConfirm"
                  ? "请点击“去预约”继续提交预约"
                  : "请点击“去开单申请”继续提交开单申请",
              confirmButtonText:
                this.$route.query.callbackUrl == "servePreOrderConfirm"
                  ? "去预约"
                  : "去开单申请",
            }).then(() => {
              that.$router.push({
                name: this.$route.query.callbackUrl,
                query: {
                  Id: this.contactInfo.id,
                },
                params: {
                  applyPackageValue: this.$route.query.applyPackageValue,
                },
              });
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchInfo(id) {
      this.$post("GetFormRecordInfoById", { id: id }).then(res => {
        this.info = res.data;
        this.readonly = true;
        document.scrollingElement.scrollTop = 0;
      });
    },
    onPatientIdentityNoChange(e) {
      const value = e.target.value;
      if (value) {
        const verifyIdCard = IdentityCodeValid(value);
        if (verifyIdCard && verifyIdCard.state === "success") {
          // 自动填写 生日 性别
          this.baseFormData.patientSex = verifyIdCard.sex;
          this.baseFormData.patientAge = getAges(verifyIdCard.birthday);
          this.idCardErrorMsg = "";
        } else {
          this.idCardErrorMsg = verifyIdCard.msg;
        }
      }
    },
    // 处理接口返回的赋值到表单
    setData(info) {
      this.readonly = true;
      this.info = info;
      this.baseFormData = {
        hospitalId: info.hospitalId,
        diagnosisCardNo: info.diagnosisCardNo,
        patientName: info.patientName,
        patientSex: info.patientSex,
        patientIdentityNo: info.patientIdentityNo,
        patientContactPhone: info.patientContactPhone,
      };
      let formData = {};
      if (info.itemList && info.itemList.length) {
        for (let i = 0; i < info.itemList.length; i++) {
          const item = info.itemList[i];
          if (item.childItemList && item.childItemList.length) {
            for (let j = 0; j < item.childItemList.length; j++) {
              const subject = item.childItemList[j];
              let value = "";
              if (subject.valueList && subject.valueList.length) {
                value = subject.valueList[0];
              }
              if (subject.isEscortInput) {
                // 陪护信息
                formData[`${i}_${j}_0`] = value;
                if (subject.valueList && subject.valueList.length == 2) {
                  formData[`${i}_${j}_1`] = subject.valueList[1];
                }
              } else {
                formData[`${i}_${j}_`] = value;
              }
            }
          }
        }
      }
      this.hideItemKeys = [];
      this.formData = formData;
    },
    onShowDatePicker(field) {
      if (this.readonly) {
        return;
      }
      this.currentDatePickerField = field;
      this.showDatePicker = true;
    },
    onConfirmDatePicker(v) {
      const date = formatDate(v, "yyyy-MM-dd");
      this.formData[this.currentDatePickerField] = date;
      this.showDatePicker = false;
    },
    onInputChange(e, key) {
      const { value } = e.target;
      if (this.templateData.formTemplateType == 2 && key == "0_1_" && value) {
        //2022模板的身份证
        const verifyIdCard = IdentityCodeValid(value);
        console.log(verifyIdCard);
        if (verifyIdCard && verifyIdCard.state === "success") {
          // 自动填写 生日 性别
          this.formData["0_2_"] = verifyIdCard.sex + "";
          this.formData["0_3_"] = getAges(verifyIdCard.birthday);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f1f1f1;
}
.form-config-list {
  font-size: 16px;
}
.content {
  padding-top: 50px;
}
.content.notPage {
  padding-top: 0;
}

/deep/.van-radio--horizontal {
  margin-right: 0.6rem;
}

.form-config-list {
  font-size: 14px;
  .title {
    font-size: 18px;
    color: #777;
    font-weight: 500;
    padding: 10px 20px;
  }
  .subject-list {
    background: #fff;
    padding: 10px;
    .subject-item {
      padding: 5px 0;
      & + .subject-item {
        border-top: 1px solid #ddd;
      }
      .subject-title {
        margin-bottom: 10px;
        line-height: 1.6;
      }
      &.inline {
        .subject-title {
          display: inline-block;
          width: 110px;
          text-align: right;

          // padding-right: 10px;
          &::after {
            content: ":";
            position: relative;
            top: -0.5px;
            margin: 0 8px 0 2px;
          }
        }
        .option-list {
          display: inline-block;
        }
      }
    }
  }
}
.required {
  overflow: visible;
  position: relative;
  padding-left: 8px;
}
.required:before {
  color: #ee0a24;
  content: "*";
  font-size: 14px;
  left: 0px;
  // position: absolute;
  display: inline-block;
}
.option-list {
  padding: 3px 0;
  .option-title {
  }
  .van-cell {
    padding: 0px;
  }
  /deep/.van-field__control {
    width: 220px;
  }
}
.subject-remark {
  color: #999;
  font-size: 14px;
}
.van-checkbox--horizontal {
  margin-bottom: 15px;
}
.action-wraper {
  padding: 10px;
  margin-top: 30px;
}
.submit-result {
  text-align: center;
  padding: 30px;
  font-size: 14px;
  .icon {
    font-size: 60px;
    color: @green;
  }
}
.header-title {
  text-align: center;
  color: #555;
  font-size: 14px;
  h3 {
    font-size: 20px;
    margin-bottom: 0;
  }
  h4 {
    font-size: 16px;
    margin: 10px 0 0;
  }
}
.date-cell {
}

/deep/.van-radio-group--horizontal {
  .van-radio--horizontal {
    margin-bottom: 10px;
  }
  .van-radio__label {
    min-width: 55px;
  }
}
</style>
